import { Identifiable, ProjectStrategicAxis } from "@planzone/dto";
import { HttpClient, HttpMethods } from "../types/httpClient";

function editProjectStrategicAxis(httpClient: HttpClient) {
  return (
    projectStrategicAxis: Identifiable<ProjectStrategicAxis>,
    nextProjectStrategicAxis: ProjectStrategicAxis,
  ) =>
    new Promise<Identifiable<ProjectStrategicAxis>>((resolve, reject) =>
      httpClient
        .sendHttpRequest<Identifiable<ProjectStrategicAxis>>({
          endpoint: `/projectStrategicAxeses/${projectStrategicAxis.uuid}`,
          method: HttpMethods.PATCH,
          data: {
            ...projectStrategicAxis,
            consistencyValue: nextProjectStrategicAxis.consistencyValue,
          },
        })
        .then((projectStrategicAxis) => projectStrategicAxis)
        .then(resolve)
        .catch((e) => reject({ ...e, message: e.detail || "" })),
    );
}

export { editProjectStrategicAxis };
